<script>
	import Data from '../../States/Data';
	import Helper from '../../Models/Helper';
	import Session from '../../States/Session';
	import Slider from '../../States/Slider';

	export let index = 0;

	let properties = {};
	let version = {};
	let current = {};
	let active = false;

	async function init() {
		version = await Data.relative('version');
		for (let item of version.testaments)
			if (item.code == properties.testament)
				current = item;

		title();
		canonical();
	}

	function updateSlider(slides) {
		active = Slider.check(index, 'books', properties);
		if (active) {
			properties = Slider.properties(index);
			active = properties.active;
			title();
			canonical();
		}
	}

	function title() {
		if (active)
			Helper.title(current.name);
	}

	function canonical() {
		if (active) {
			const old = current.code === 'OT';
			const uri = old ? 'oude-testament' : 'nieuwe-testament';
			Helper.canonical(uri);
		}
	}

	function chapters() {
		Slider.route(['chapters', this.code]);
	}

	function previous() {
		Slider.route('previous', 'next');
	}

	function next() {
		Slider.route('next', 'previous');
	}

	init();
	Slider.subscribe(updateSlider);
</script>

<style>
	h3.solid.list {
		color: var(--secondary-color);
	}

	div.testament {
		margin-bottom: 3em;
	}

	div.testament .button {
		text-align: left;
	}

	div.list div.name i {
		margin-right: .5em;
		opacity: .5;
	}

	@media (max-device-width: 768px) {
		h1 {
			margin-top: 0 !important;
		}
	}
</style>

<div class="box feature" class:active>
	{#if Helper.is(version)}
		{#each version.testaments as item, counter}
			{#if item.code == properties.testament}
				<div class="menu">
					<div class="begin">
						{#if counter}
							<a class="item" href="/oude-testament">
								<i class="fas fa-chevron-left"></i>
							</a>
						{/if}
						{#if item.code == 'OT'}
							<div class="title">Oude Testament</div>
						{:else}
							<div class="title">Nieuwe Testament</div>
						{/if}
					</div>
					<div class="end">
						{#if !counter}
							<a class="item" href="/nieuwe-testament">
								<i class="fas fa-chevron-right"></i>
							</a>
						{/if}
						<div class="item" on:click="{event => Slider.close()}">
							<i class="fas fa-times"></i>
						</div>
					</div>
				</div>
				<div class="content">
					<div class="testament">
						{#if item.code == 'OT'}
							<a class="button attention" href="/nieuwe-testament">
								<i class="fad fa-arrow-right"></i>
								Nieuwe Testament
							</a>
						{:else}
							<a class="button attention button-icon-left" href="/oude-testament">
								<i class="fad fa-arrow-left"></i>
								Oude Testament
							</a>
						{/if}
					</div>
					{#if item.code == 'OT'}
						<h1>Oude Testament</h1>
						{#if $Data.version.code == 'BB'}
							<p>Het oude testament is het eerste deel van de bijbel. Hierin staan alle boeken uit de tijd vóór Jezus’ geboorte.</p>
						{:else}
							<p></p>
						{/if}
					{:else}
						<h1>Nieuwe Testament</h1>
						{#if $Data.version.code == 'BB'}
							<p>Het nieuwe testament is het tweede deel van de bijbel. Hierin staan de boeken die over het leven van Jezus en het geloof in Jezus gaan.</p>
						{:else}
							<p></p>
						{/if}
					{/if}
					<h3 class="solid list">Boeken</h3>
					<div class="solid list">
						{#each item.books as book}
							<a class="item" href="/{book.uri}">
								<i class="fad fa-chevron-right"></i>
								<div class="name">
									<i class="fad fa-book"></i> {book.name}
								</div>
							</a>
						{/each}
					</div>
				</div>
			{/if}
		{/each}
	{/if}
</div>